import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import { partnerRoles, StatusOperations, StatusTypes } from 'const';
import { MODAL_OPEN } from 'redux/slices/modals';
// eslint-disable-next-line import/no-cycle
import { Button, Tooltip } from 'ui/atoms';
import MainFont from 'ui/typography/mainFont';

// eslint-disable-next-line import/no-cycle
import { ButtonContainer, ItemsContainer, PanelContainer } from './style';

export const buttonStyle = {
  ENABLE: 'Enable',
  DISABLE: 'Disable'
};

const SelectionPanel = ({
  selectedRows = [],
  selectAll,
  removeAll,
  updateAccountStatus,
  deleteAccount,
  changeUserRole,
  currentRole,
  isChargerList,
  openCta,
  isPeopleList,
  isRFIDList,
  openPeopleModal,
  openRfidModal,
  isLeadsList,
  openLeadsModal,
  updateLeadsStatus
}) => {
  const { t } = useTranslation();
  const [activateDisabled, setActivateDisabled] = useState(false);
  const [suspendDisabled, setSuspendDisabled] = useState(false);
  const [deleteDisabled, setDeleteDisabled] = useState(false);

  const onUpdateAccountStatus = (type, targetRole) => {
    const ids = selectedRows.map(row => {
      if (row.cognitoId) {
        return row.cognitoId;
      }
      return row.email.split('@')?.[0];
    });
    if (type === StatusOperations.DELETE) {
      deleteAccount(ids);
    } else if (type === StatusOperations.CHANGEROLE) {
      changeUserRole(ids[0], targetRole, selectedRows);
    } else {
      updateAccountStatus(ids, type);
    }
    removeAll();
  };

  const updateRFIDStatus = type => {
    const ids = selectedRows.map(row => row.rfidNumber);
    updateAccountStatus(ids, type);
    removeAll();
  };

  const handleUpdateLeadsStatus = () => {
    const ids = selectedRows.map(row => row.leadId);
    updateLeadsStatus({ leadIds: ids, targetStatus: 'NOT_INTERESTED' });
    removeAll();
  };

  const handleModalPeople = modalType => {
    openPeopleModal({
      count: selectedRows.length,
      onAccept: onUpdateAccountStatus,
      data: selectedRows,
      modalType
    });
  };
  const handleModalRfid = modalType =>
    openRfidModal({
      count: selectedRows.length,
      onAccept: updateRFIDStatus,
      modalType
    });

  const handleLeadsModal = () => {
    openLeadsModal({
      count: selectedRows.length,
      onAccept: handleUpdateLeadsStatus,
      data: selectedRows
    });
  };

  const onEnable = () => {
    if (isRFIDList) {
      handleModalRfid(StatusOperations.ENABLE);
    } else {
      handleModalPeople(StatusOperations.ENABLE);
    }
  };

  const onDisable = () => {
    if (isRFIDList) {
      handleModalRfid(StatusOperations.DISABLE);
    } else {
      handleModalPeople(StatusOperations.DISABLE);
    }
  };

  const onDelete = () => {
    handleModalPeople(StatusOperations.DELETE);
  };

  const onChangeRole = () => {
    handleModalPeople(StatusOperations.CHANGEROLE);
  };

  const onStatusLeadsUpdate = () => {
    handleLeadsModal();
  };

  const peopleButtons = () => {
    const canChangeRole = () =>
      (currentRole === partnerRoles.ADMIN ||
        currentRole === partnerRoles.SYSTEM_ADMIN) &&
      selectedRows?.length < 2;

    return (
      <ButtonContainer>
        <Button
          variant="charger-button"
          disabled={activateDisabled}
          onClick={onEnable}
          data-tip={t('select_only_disabled_accounts')}
          data-html
        >
          {t('enable')}
        </Button>
        <Button
          variant="charger-button"
          disabled={suspendDisabled}
          onClick={onDisable}
          data-tip={t('select_only_enabled_accounts')}
          data-html
        >
          {t('disable')}
        </Button>
        {canChangeRole() && (
          <Button variant="charger-button" onClick={onChangeRole}>
            {t('change_role')}
          </Button>
        )}
        <Button
          variant="charger-button"
          onClick={onDelete}
          disabled={deleteDisabled}
          Ï
          data-tip={t('select_only_disabled_accounts')}
          data-html
        >
          {t('delete')}
        </Button>
        <Tooltip />
      </ButtonContainer>
    );
  };

  const leadsButtons = () => (
    <ButtonContainer>
      <Button
        variant="charger-button"
        onClick={onStatusLeadsUpdate}
        disabled={deleteDisabled}
      >
        {t('change_status')}
      </Button>
      <Tooltip />
    </ButtonContainer>
  );

  useEffect(() => {
    const activeRows = selectedRows.filter(
      row => row.status === StatusTypes.ENABLED
    )?.length;

    const disabledRows = selectedRows.filter(
      row => row.status === StatusTypes.DISABLED
    )?.length;

    const pendingRows = selectedRows?.length - activeRows - disabledRows;
    if (activeRows === selectedRows?.length) {
      setActivateDisabled(true);
      setSuspendDisabled(false);
      setDeleteDisabled(true);
    } else if (disabledRows === selectedRows?.length) {
      setActivateDisabled(false);
      setSuspendDisabled(true);
      setDeleteDisabled(false);
    } else if (pendingRows === selectedRows?.length) {
      setActivateDisabled(true);
      setSuspendDisabled(true);
      setDeleteDisabled(false);
    } else {
      setActivateDisabled(true);
      setSuspendDisabled(true);
      setDeleteDisabled(true);
    }
  }, [selectedRows]);

  return (
    <PanelContainer>
      <ItemsContainer>
        {/*<div onClick={onRadioButtonClick}>
          {selectAllChecked ? (
            <IconWrapper>
              <Icon
                type="icon-checkok"
                size="15"
                color={theme().colors.white}
              />
            </IconWrapper>
          ) : (
            <VoidIcon />
          )}
        </div>
        <ItemContainer>
          <MainFont type="selectAllText"> {t('select_all')} </MainFont>
        </ItemContainer>*/}
        <MainFont type="blueLabel">
          {selectedRows.length} {isRFIDList && t('rfids_selected')}
          {isPeopleList && t('accounts_selected')}
          {isChargerList && t('chargers_selected')}
          {isLeadsList && t('leads_selected')}
        </MainFont>
      </ItemsContainer>
      {isPeopleList && peopleButtons()}
      {isLeadsList && leadsButtons()}
    </PanelContainer>
  );
};

SelectionPanel.propTypes = {
  selectedRows: PropTypes.array,
  selectAll: PropTypes.func,
  removeAll: PropTypes.func,
  updateAccountStatus: PropTypes.func,
  deleteAccount: PropTypes.func,
  changeUserRole: PropTypes.func,
  isPeopleList: PropTypes.bool,
  currentRole: PropTypes.string,
  openPeopleModal: PropTypes.func,
  isLeadsList: PropTypes.bool,
  openLeadsModal: PropTypes.func,
  updateLeadsStatus: PropTypes.func
};

export default connect(
  state => ({
    currentRole: state?.authentication?.role
  }),
  dispatch => ({
    openPeopleModal: payload =>
      dispatch(MODAL_OPEN({ id: 'PeopleModal', payload })),
    openLeadsModal: payload =>
      dispatch(MODAL_OPEN({ id: 'LeadsStatusModal', payload }))
  })
)(SelectionPanel);
